import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Layout, { PageHero } from "@/components/Layout";
import api from "@/lib/api";

const fade = { initial: { opacity: 0, y: 18 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true }, transition: { duration: 0.45 } };

export default function News() {
  const [news, setNews] = useState(null);
  useEffect(() => { api.get("/news").then((r) => setNews(r.data)).catch(() => setNews([])); }, []);

  return (
    <Layout>
      <PageHero crumb={<><Link to="/">Home</Link> / News</>} title="News" subtitle="Milestones, patents, press and partnerships from Cerebral Diagnostics." />
      <section className="section">
        <div className="wrap">
          {news === null ? (
            <p style={{ color: "var(--muted)" }}>Loading...</p>
          ) : news.length === 0 ? (
            <p style={{ color: "var(--muted)" }}>No news yet.</p>
          ) : (
            <>
              {news[0] && (
                <motion.div className="news-featured" {...fade} data-testid={`news-featured-${news[0].id}`}>
                  <span className="nf-badge">Latest announcement</span>
                  <span className="nf-date">{news[0].date}</span>
                  <h2 className="nf-title">{news[0].title}</h2>
                  <p className="nf-summary">{news[0].summary || news[0].body?.slice(0, 220)}</p>
                  <div className="nf-actions">
                    {news[0].link
                      ? <a href={news[0].link} target="_blank" rel="noreferrer" className="btn btn-primary">Read more</a>
                      : <Link to={`/news/${news[0].id}`} className="btn btn-primary">Read more</Link>}
                  </div>
                </motion.div>
              )}
              {news.length > 1 && (
                <div className="news-grid" data-testid="news-list" style={{ marginTop: 40 }}>
                  {news.slice(1).map((n, i) => (
                    <motion.div className="news-card" key={n.id} {...fade} transition={{ duration: 0.45, delay: (i % 3) * 0.06 }} data-testid={`news-item-${n.id}`}>
                      <span className="news-date">{n.date}</span>
                      <h3>{n.title}</h3>
                      <p>{n.summary || n.body?.slice(0, 140)}</p>
                      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                        {n.link
                          ? <a href={n.link} target="_blank" rel="noreferrer" className="news-more">Read more</a>
                          : <Link to={`/news/${n.id}`} className="news-more">Read more</Link>}
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </Layout>
  );
}
